import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { CombinedState } from 'reducers';
import { fetchAnnotationsAsync, saveAnnotationsAsync } from 'actions/annotation-actions';
import { t } from 'utils/i18n';
import { isReferenceJob } from 'utils/reference-job';
import { finderFor, RelabelFill } from './relabel-fill';
import type { StateLike } from './references/reference-model';

export default function RelabelFillContainer(): JSX.Element | null {
    const dispatch = useDispatch();
    const { tid } = useParams<{ tid?: string }>();
    const job = useSelector((state: CombinedState) => state.annotation.job.instance);
    const states = useSelector((state: CombinedState) => state.annotation.annotations.states);

    const collect = useCallback(async (frame: number): Promise<StateLike[]> => (
        job.annotations.get(frame, false, [])
    ), [job]);
    const save = useCallback(async () => {
        await dispatch(saveAnnotationsAsync() as any);
        if (job.annotations.hasUnsavedChanges()) throw new Error(t('Your changes could not be saved'));
    }, [dispatch, job]);
    const reload = useCallback(async () => { await dispatch(fetchAnnotationsAsync(true) as any); }, [dispatch]);
    const find = useCallback(async (ids: number[]) => {
        await finderFor(job.id, isReferenceJob(job) ? Number(tid) : null)(ids);
    }, [job, tid]);

    if (!job) return null;
    return <RelabelFill states={states} collect={collect} save={save} find={find} reload={reload} />;
}
